var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"orders"},[_c('PageTitle',{attrs:{"text":"Commandes"}}),(_vm.$vuetify.breakpoint.xsOnly)?_c('div',[_c('OrdersMobile')],1):_c('div',[_c('OrdersDatatable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }